// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"771ff1e9689b6ad37d63","691":"2aa12e9ebde89a2ce490"}[chunkId] + ".js";
};